import { GetRequestDocumentsQueryKey } from '../api/useGetRequestDocuments'
import { GetSupplierDocumentsQueryKey } from '../api/useGlobalDocuments'
import { AGREEMENT_DOCUMENTS_QUERY_KEY, DOCUMENTS_QUERY_KEY } from '../constants'
import type { QueryKey } from '@tanstack/react-query'

/** Every table that lists documents: a mark made on one shows on all of them. */
export const DOCUMENT_LIST_QUERY_KEYS: QueryKey[] = [
  [DOCUMENTS_QUERY_KEY],
  [GetSupplierDocumentsQueryKey],
  [AGREEMENT_DOCUMENTS_QUERY_KEY],
  [GetRequestDocumentsQueryKey],
]
